(function () {
  if (document.documentElement.classList.contains('shopify-design-mode')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ─── DARK BACKGROUND LOCK — prevents white flash before theme CSS loads ─── */
  (function () {
    var s = document.createElement('style');
    s.id = 'provit-dark-lock';
    s.textContent = [
      'html,body{background:#000!important}',
      /* Force ALL sections AND their direct children dark — overrides page builders (EComposer/PageFly) that set bg on inner divs */
      '.shopify-section{background:#0a0a0a!important}',
      '.shopify-section>div,.shopify-section>section,.shopify-section>main{background:#0a0a0a!important}',
      '.shopify-section+.shopify-section{margin-top:0!important}',
      /* Judge.me reviews widget — full dark override */
      '.jdgm-widget,.jdgm-rev-widg,.jdgm-rev-widg__inner,.jdgm-widget__body{background:#0a0a0a!important}',
      '.jdgm-rev{background:#111111!important;border-color:#2c2c2c!important}',
      '.jdgm-rev__body,.jdgm-rev__author,.jdgm-rev__timestamp,.jdgm-rev__title,.jdgm-rev__content{color:#f5f2ed!important}',
      '.jdgm-star,.jdgm-all-stars,.jdgm-rev__rating{color:#c9a84c!important}',
      '.jdgm-widget__title,.jdgm-rev-widg__title,.jdgm-widget__score,.jdgm-widget__score-and-summary{color:#ffffff!important}',
      '.jdgm-rev-widg__summary-text,.jdgm-summary-score{color:#b0b0b0!important}',
      '.jdgm-paginate a{color:#c9a84c!important}',
      '.jdgm-paginate__page.active,.jdgm-paginate__page.jdgm--active{background:#c9a84c!important;color:#000!important;border-radius:4px!important}',
      '.jdgm-write-rev-link,.jdgm-sorting{color:#c9a84c!important}',
    ].join('');
    document.documentElement.insertBefore(s, document.documentElement.firstChild);
  }());

  /* ─── PRODUCT PAGE — premium styles injected before paint ─── */
  if (document.body.classList.contains('template-product')) {
    (function () {
      var s = document.createElement('style');
      s.id = 'provit-product-styles';
      s.textContent = [
        /* Force ALL product page sections AND their first-level children dark */
        '.template-product .shopify-section,',
        '.template-product .shopify-section>div,',
        '.template-product .shopify-section>section{background:#0a0a0a!important}',

        /* Gold token system */
        '.template-product{',
          '--pg:#c9a84c;--pg-l:#e6c76a;--pg-d:#9a7830;',
          '--pg-glow:rgba(201,168,76,0.35);',
          '--psurf:#0d0d0d;--pborder:#1e1e1e;',
        '}',

        /* Price — gold */
        '.template-product .price__regular .money,',
        '.template-product .price-item--regular,',
        '.template-product .price .money{color:var(--pg)!important;font-weight:700!important}',

        /* Primary button — gold gradient */
        '.template-product .button,',
        '.template-product .button--primary,',
        '.template-product [type="submit"]:not(.shopify-payment-button__button--branded){',
          'background:linear-gradient(135deg,var(--pg-d),var(--pg),var(--pg-l))!important;',
          'color:#000!important;font-weight:700!important;letter-spacing:.06em!important;',
          'border:none!important;border-radius:8px!important;',
          'box-shadow:0 4px 24px var(--pg-glow)!important;',
          'transition:transform .25s,box-shadow .25s!important;',
        '}',
        '.template-product .button:hover,',
        '.template-product .button--primary:hover{',
          'transform:translateY(-2px)!important;',
          'box-shadow:0 12px 40px var(--pg-glow)!important;',
        '}',

        /* Gold divider line */
        '.template-product hr{',
          'border:none!important;height:1px!important;opacity:.4!important;',
          'background:linear-gradient(90deg,transparent,var(--pg) 40%,var(--pg) 60%,transparent)!important;',
        '}',

        /* FAQ / details accordion */
        '.template-product details{',
          'background:var(--psurf)!important;',
          'border:1px solid var(--pborder)!important;',
          'border-radius:10px!important;margin-bottom:8px!important;overflow:hidden!important;',
        '}',
        '.template-product details summary{',
          'padding:18px 20px!important;color:#f0f0f0!important;cursor:pointer!important;',
          'font-weight:500!important;list-style:none!important;',
          'border-left:3px solid var(--pg)!important;',
          'transition:color .2s,background .2s!important;',
          'display:flex!important;justify-content:space-between!important;align-items:center!important;',
        '}',
        '.template-product details summary::-webkit-details-marker{display:none}',
        '.template-product details summary:hover{color:var(--pg)!important;background:#111!important}',
        '.template-product details[open] summary{',
          'color:var(--pg)!important;border-bottom:1px solid var(--pborder)!important;',
        '}',
        '.template-product details>*:not(summary){',
          'padding:16px 20px!important;color:#ccc!important;line-height:1.75!important;',
        '}',

        /* Quantity */
        '.template-product quantity-input input,',
        '.template-product [class*="quantity__input"]{',
          'background:var(--psurf)!important;border:1px solid var(--pborder)!important;color:#fff!important;',
        '}',
        '.template-product quantity-input button,',
        '.template-product [class*="quantity__button"]{',
          'background:var(--psurf)!important;border:1px solid var(--pborder)!important;color:var(--pg)!important;',
        '}',

        /* Thumbnail active — gold border */
        '.template-product [class*="thumbnail"] [aria-current="true"] img,',
        '.template-product [class*="thumbnail"]:hover img{',
          'outline:2px solid var(--pg)!important;border-radius:8px!important;',
        '}',

        /* Stars gold */
        '.template-product [class*="jdgm-star"],',
        '.template-product [class*="star--filled"]{color:var(--pg)!important;fill:var(--pg)!important}',
        '.template-product svg[class*="star"] path{fill:var(--pg)!important}',

        /* Section headings */
        '.template-product .shopify-section h2,',
        '.template-product .shopify-section h3{color:#fff!important}',

        /* Product image rounded */
        '.template-product [class*="product__media"] img,',
        '.template-product [class*="media-gallery"] img{border-radius:14px!important}',

        /* Stock indicator */
        '.template-product [class*="inventory"]:not(:empty){color:#10b981!important}',

        /* Section breathing room */
        '.template-product .shopify-section{padding-block:clamp(32px,5vw,80px)!important}',

        /* Sticky ATC bar */
        '.template-product [class*="sticky"]{',
          'background:#0d0d0d!important;border-top:1px solid var(--pborder)!important;',
          'backdrop-filter:blur(12px)!important;',
        '}',

        /* Review widget dark */
        '.template-product .jdgm-widget,',
        '.template-product [class*="jdgm"]{background:#000!important;color:#f0f0f0!important}',
        '.template-product .jdgm-rev__rating{color:var(--pg)!important}',

        /* Provit gold glowing CTA accent */
        '@keyframes provit-pulse{',
          '0%,100%{box-shadow:0 4px 24px rgba(201,168,76,.35)}',
          '50%{box-shadow:0 6px 40px rgba(201,168,76,.65)}',
        '}',
        '.template-product [name="add"]{animation:provit-pulse 2.8s ease-in-out infinite!important}',

        /* Hide the green "Acheter maintenant / Paiement à la livraison" accelerated checkout button */
        '.template-product .shopify-payment-button{display:none!important}',
        '.template-product [class*="accelerated-checkout"]{display:none!important}',
        '.template-product .dynamic-checkout{display:none!important}',
      ].join('');
      document.head.appendChild(s);
    }());
  }

  function loadScript(src, cb) {
    var s = document.createElement('script');
    s.src = src;
    s.onload = cb;
    document.head.appendChild(s);
  }

  function boot() {
    loadScript('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js', function () {
      loadScript('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js', function () {
        gsap.registerPlugin(ScrollTrigger);
        window.addEventListener('load', function () { ScrollTrigger.refresh(); });
        initPageTransition();
        initAnimations();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* ─── PAGE TRANSITIONS ─── */
  function initPageTransition() {
    var overlay = document.createElement('div');
    overlay.id = 'provit-page-overlay';
    overlay.style.cssText = [
      'position:fixed;inset:0;background:#000;z-index:9999;',
      'pointer-events:none;opacity:1;',
      'top:0;left:0;width:100%;height:100%;',
    ].join('');
    document.documentElement.appendChild(overlay);

    gsap.to(overlay, { opacity: 0, duration: 0.5, ease: 'power2.out', delay: 0.05 });

    document.addEventListener('click', function (e) {
      var link = e.target.closest('a');
      if (!link) return;
      var href = link.getAttribute('href');
      if (
        !href || href.charAt(0) === '#' || href.indexOf('javascript') === 0 ||
        link.target === '_blank' || e.ctrlKey || e.metaKey || e.shiftKey ||
        link.hasAttribute('data-no-transition')
      ) return;
      e.preventDefault();
      gsap.to(overlay, {
        opacity: 1, duration: 0.38, ease: 'power2.in',
        onComplete: function () { window.location.href = href; },
      });
    });
  }

  /* ─── MAIN ANIMATIONS ─── */
  function initAnimations() {

    /* 1. HERO ENTRANCE */
    var heroSection = document.querySelector('.shopify-section:first-child');
    if (heroSection) {
      var tl = gsap.timeline({ delay: 0.4 });
      var heroMedia = heroSection.querySelector(
        'img, video, .banner__media, [class*="hero__media"], [class*="slideshow__media"]'
      );
      if (heroMedia) {
        tl.fromTo(heroMedia,
          { scale: 1.06, opacity: 0 },
          { scale: 1, opacity: 1, duration: 1.4, ease: 'power3.out' }
        );
      }
      var heroHeading = heroSection.querySelector('h1, h2, [class*="__heading"]');
      if (heroHeading) {
        tl.fromTo(heroHeading,
          { y: 30, opacity: 0 },
          { y: 0, opacity: 1, duration: 0.9, ease: 'power3.out' },
          '-=1.0'
        );
      }
      var heroSub = heroSection.querySelector('p, [class*="subtitle"], [class*="subtext"], [class*="__text"]');
      if (heroSub) {
        tl.fromTo(heroSub,
          { y: 20, opacity: 0 },
          { y: 0, opacity: 1, duration: 0.75, ease: 'power3.out' },
          '-=0.65'
        );
      }
      var heroBtns = heroSection.querySelectorAll('a[class*="button"], .button, [class*="__button"]');
      if (heroBtns.length) {
        tl.fromTo(heroBtns,
          { y: 15, opacity: 0, scale: 0.96 },
          { y: 0, opacity: 1, scale: 1, duration: 0.65, stagger: 0.1, ease: 'back.out(1.4)' },
          '-=0.45'
        );
      }
    }

    /* 2. SECTIONS SCROLL REVEAL — opacity only, no y-shift to prevent gaps between sections */
    document.querySelectorAll('.shopify-section').forEach(function (section, i) {
      if (i === 0) return;
      gsap.fromTo(section,
        { opacity: 0 },
        {
          opacity: 1, duration: 0.7, ease: 'power2.out',
          immediateRender: true,
          scrollTrigger: { trigger: section, start: 'top 90%', once: true },
        }
      );
    });

    /* 3. HEADINGS — clean fade up */
    document.querySelectorAll('.shopify-section h2, .shopify-section h3').forEach(function (el) {
      gsap.fromTo(el,
        { opacity: 0, y: 18 },
        {
          opacity: 1, y: 0, duration: 0.7, ease: 'power2.out',
          immediateRender: false,
          scrollTrigger: { trigger: el, start: 'top 92%', once: true },
        }
      );
    });

    /* 4. PRODUCT CARDS — stagger in */
    var gridSelectors = [
      '[data-testid="product-list"]',
      '[data-testid="collection-list"]',
      '.section-resource-list',
      '.product-grid',
      '.collection-grid',
    ].join(', ');
    document.querySelectorAll(gridSelectors).forEach(function (group) {
      var cards = group.querySelectorAll('.resource-list__item, .product-card, .card-wrapper, li');
      if (!cards.length) return;
      ScrollTrigger.batch(cards, {
        start: 'top 95%', once: true,
        onEnter: function (batch) {
          gsap.fromTo(batch,
            { opacity: 0, y: 28 },
            { opacity: 1, y: 0, stagger: 0.08, duration: 0.65, ease: 'power2.out' }
          );
        },
      });
      cards.forEach(function (card) {
        var img = card.querySelector('img');
        if (!img) return;
        img.style.transformOrigin = 'center center';
        card.addEventListener('mouseenter', function () {
          gsap.to(img, { scale: 1.07, duration: 0.5, ease: 'power2.out', overwrite: true });
        });
        card.addEventListener('mouseleave', function () {
          gsap.to(img, { scale: 1, duration: 0.45, ease: 'power2.inOut', overwrite: true });
        });
      });
    });

    /* 5. HERO BANNER PARALLAX */
    document.querySelectorAll(
      '.banner__media img, .banner__media video, [class*="slideshow__slide"] img'
    ).forEach(function (bg) {
      var section = bg.closest('.shopify-section') || bg.parentElement;
      gsap.to(bg, {
        yPercent: 15, ease: 'none',
        scrollTrigger: { trigger: section, start: 'top top', end: 'bottom top', scrub: true },
      });
    });

    /* 6. MEDIA-WITH-CONTENT — slide from sides */
    document.querySelectorAll('[data-testid="media-with-content"]').forEach(function (section) {
      var isRight = section.classList.contains('media-with-content--media-right');
      var mediaEl = section.querySelector('img, video');
      var contentEl = section.querySelector('[class*="content"]');
      if (mediaEl) {
        gsap.fromTo(mediaEl,
          { opacity: 0, x: isRight ? 50 : -50 },
          { opacity: 1, x: 0, duration: 1, ease: 'power3.out', immediateRender: false,
            scrollTrigger: { trigger: section, start: 'top 85%', once: true } }
        );
      }
      if (contentEl) {
        gsap.fromTo(contentEl,
          { opacity: 0, x: isRight ? -45 : 45 },
          { opacity: 1, x: 0, duration: 1, ease: 'power3.out', immediateRender: false,
            scrollTrigger: { trigger: section, start: 'top 85%', once: true } }
        );
      }
    });

    /* 7. FEATURED PRODUCT — split slide in */
    document.querySelectorAll('.featured-product-section').forEach(function (section) {
      var media = section.querySelector('img, video');
      var info = section.querySelector('[class*="product-info"], [class*="content"]');
      if (media) {
        gsap.fromTo(media,
          { opacity: 0, x: -50 },
          { opacity: 1, x: 0, duration: 1, ease: 'power3.out', immediateRender: false,
            scrollTrigger: { trigger: section, start: 'top 82%', once: true } }
        );
      }
      if (info) {
        gsap.fromTo(info,
          { opacity: 0, x: 50 },
          { opacity: 1, x: 0, duration: 1, ease: 'power3.out', immediateRender: false,
            scrollTrigger: { trigger: section, start: 'top 82%', once: true } }
        );
      }
    });

    /* 8. STICKY HEADER BLUR */
    var headerEl = document.querySelector('header-component, header, #header-group');
    if (headerEl) {
      var style = document.createElement('style');
      style.textContent = [
        'header-component,header{transition:box-shadow .3s ease,backdrop-filter .3s ease}',
        'body.provit-scrolled header-component,body.provit-scrolled header{',
        'backdrop-filter:blur(12px) saturate(1.8);',
        '-webkit-backdrop-filter:blur(12px) saturate(1.8);',
        'box-shadow:0 2px 24px rgba(0,0,0,.1)}',
      ].join('');
      document.head.appendChild(style);
      ScrollTrigger.create({
        start: 'top top-=80',
        onEnter: function () { document.body.classList.add('provit-scrolled'); },
        onLeaveBack: function () { document.body.classList.remove('provit-scrolled'); },
      });
    }

    /* 9. BUTTON MAGNETIC HOVER */
    document.querySelectorAll('.button--primary, [class*="button--primary"]').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * 0.25;
        var y = (e.clientY - r.top - r.height / 2) * 0.25;
        gsap.to(btn, { x: x, y: y, duration: 0.3, ease: 'power2.out', overwrite: true });
      });
      btn.addEventListener('mouseleave', function () {
        gsap.to(btn, { x: 0, y: 0, duration: 0.55, ease: 'elastic.out(1,0.5)', overwrite: true });
      });
    });

    /* ─── 10. PRODUCT PAGE ANIMATIONS ─── */
    if (document.body.classList.contains('template-product')) {

      /* Media gallery — slide in from left */
      var productGallery = document.querySelector(
        '[class*="product__media"], [class*="media-gallery"], [class*="product-media"]'
      );
      if (productGallery) {
        gsap.fromTo(productGallery,
          { opacity: 0, x: -50, scale: 0.97 },
          { opacity: 1, x: 0, scale: 1, duration: 1.1, ease: 'power3.out', delay: 0.35 }
        );
      }

      /* Product details — stagger from right */
      var detailBlocks = document.querySelectorAll([
        '[class*="product-details"] h1',
        '[class*="product-details"] [class*="price"]',
        '[class*="product-details"] [class*="review"]',
        '[class*="product-details"] [class*="inventory"]',
        '[class*="product-details"] [class*="variant"]',
        '[class*="product-details"] [class*="buy-buttons"]',
        '[class*="product-details"] [class*="accordion"]',
      ].join(', '));

      if (detailBlocks.length) {
        gsap.fromTo(detailBlocks,
          { opacity: 0, x: 40 },
          { opacity: 1, x: 0, duration: 0.7, stagger: 0.1, ease: 'power2.out', delay: 0.5 }
        );
      }

      /* Description checkmarks — stagger fade in from left */
      var descLines = document.querySelectorAll(
        '[class*="product-description"] p, [class*="product-description"] li'
      );
      if (descLines.length) {
        ScrollTrigger.batch(descLines, {
          start: 'top 93%', once: true,
          onEnter: function (batch) {
            gsap.fromTo(batch,
              { opacity: 0, x: -14 },
              { opacity: 1, x: 0, stagger: 0.07, duration: 0.5, ease: 'power2.out' }
            );
          },
        });
      }

      /* FAQ accordion items — stagger up */
      var faqItems = document.querySelectorAll('details');
      if (faqItems.length) {
        ScrollTrigger.batch(faqItems, {
          start: 'top 92%', once: true,
          onEnter: function (batch) {
            gsap.fromTo(batch,
              { opacity: 0, y: 22 },
              { opacity: 1, y: 0, stagger: 0.09, duration: 0.6, ease: 'power2.out' }
            );
          },
        });
      }

      /* Mechanism / before-after section — counter numbers count up */
      document.querySelectorAll('[class*="number"], [class*="stat"], [class*="count"]').forEach(function (el) {
        var target = parseFloat(el.textContent);
        if (!isNaN(target) && target > 0) {
          ScrollTrigger.create({
            trigger: el, start: 'top 88%', once: true,
            onEnter: function () {
              gsap.fromTo({ v: 0 }, { v: target, duration: 1.6, ease: 'power2.out',
                onUpdate: function () { el.textContent = Math.round(this.targets()[0].v); }
              });
            },
          });
        }
      });

      /* Recommendation cards — stagger in */
      var recCards = document.querySelectorAll('[class*="product-recommendations"] [class*="card"]');
      if (recCards.length) {
        ScrollTrigger.batch(recCards, {
          start: 'top 95%', once: true,
          onEnter: function (batch) {
            gsap.fromTo(batch,
              { opacity: 0, y: 30, scale: 0.97 },
              { opacity: 1, y: 0, scale: 1, stagger: 0.1, duration: 0.65, ease: 'back.out(1.3)' }
            );
          },
        });
      }

      /* Floating gold shimmer on buy button — subtle line sweep */
      var buyBtn = document.querySelector('[name="add"]');
      if (buyBtn) {
        var shimmer = document.createElement('span');
        shimmer.style.cssText = [
          'position:absolute;inset:0;border-radius:inherit;pointer-events:none;',
          'background:linear-gradient(105deg,transparent 40%,rgba(255,255,255,.25) 50%,transparent 60%);',
          'background-size:200% 100%;opacity:0;',
        ].join('');
        if (getComputedStyle(buyBtn).position === 'static') buyBtn.style.position = 'relative';
        buyBtn.appendChild(shimmer);
        gsap.to(shimmer, {
          backgroundPositionX: '-200%',
          opacity: 1,
          duration: 1.4,
          ease: 'power1.inOut',
          repeat: -1,
          repeatDelay: 2.5,
        });
      }
    }
  }
})();
